import styled from '@emotion/styled'
import { Gallery } from 'app/components/Gallery'
import { Hero } from 'app/components/Hero'
import { IntroRoom } from 'app/components/IntroRoom'
import { OtherRooms } from 'app/components/OtherRooms'
import { SEO } from 'app/components/SEO'
import { VisualBenefits } from 'app/components/VisualBenefits'
import { Footer } from 'app/containers/Footer'
import { GoogleAnalytics } from 'app/containers/GoogleAnalytics'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { StructuredData } from 'app/containers/StructuredData'
import { PageProps } from 'gatsby'
import React, { memo } from 'react'

import { Props } from './contents'

export { getRoomPageProps } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
}

export interface Context extends PageContext {
  props: Props
}

export default memo(function RoomPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <Container>
      <SEO {...context.seoProps} />
      {pageContext.headerProps ? (
        <Header
          pageID={pageContext.id}
          languageCode={pageContext.languageCode}
          languagePrefix={pageContext.languagePrefix}
          {...pageContext.headerProps}
        />
      ) : null}
      <GoogleAnalytics />
      {context.heroProps ? <Hero {...context.heroProps} /> : null}
      {context.introRoomProps ? (
        <IntroRoom {...context.introRoomProps} />
      ) : null}
      {context.galleryProps ? (
        <Gallery separator={false} {...context.galleryProps} />
      ) : null}
      {context.visualBenefitsProps ? (
        <VisualBenefits {...context.visualBenefitsProps} />
      ) : null}
      {context.otherRoomsProps ? (
        <OtherRooms {...context.otherRoomsProps} />
      ) : null}
      <Footer
        languageCode={pageContext.languageCode}
        languagePrefix={pageContext.languagePrefix}
      />
      <StructuredData languageCode={pageContext.languageCode} />
    </Container>
  )
})

const Container = styled.main``
